import React, { FC } from "react";
import PropTypes from "prop-types";

import CardScanView, { CardScanViewProps } from "./scanview";
import ScanErrorWrapper from "./scanErrorWrapper";
import { NameCase } from "../types/types";

const App = <Name extends NameCase = "snake">({
  cameraPermissionModalConfig = { enabled: true },
  webToMobileHandoffConfig = {
    enabled: false,
    urlBase: "capture.cardscan.ai",
    companyName: "CardScanHealth",
  },
  ...props
}: CardScanViewProps<Name>): React.ReactElement => {
  return (
    <ScanErrorWrapper
      sessionToken={props.sessionToken}
      fullScreen={props.fullScreen !== undefined ? props.fullScreen : true}
    >
      <CardScanView
        cameraPermissionModalConfig={cameraPermissionModalConfig}
        webToMobileHandoffConfig={webToMobileHandoffConfig}
        {...props}
      />
    </ScanErrorWrapper>
  );
};

App.propTypes = {
  logging: PropTypes.oneOf([
    "off",
    "normal",
    "verbose",
    "detector",
    "everything",
  ]),
  live: PropTypes.bool,
  sessionToken: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onProgress: PropTypes.func,
  onScanStart: PropTypes.func,
  backsideSupport: PropTypes.bool,
  cameraPermissionModalConfig: PropTypes.shape({}),
  webToMobileHandoffConfig: PropTypes.shape({}),
  _internal: PropTypes.shape({}),
};

export default App;
